const React = require('react');
const AddressFields = require('components/addresses/address_fields.jsx');

class ShippingAddressFields extends React.Component {
  render() {
    return (
      <AddressFields
        includePhoneInput
        includeNameInput
        includeSaveButton
        enabledSaveButton
        saveButtonText={I18n.t('js.addresses.addressForm.saveAddress')}
        addressTitle={I18n.t('js.addresses.addressForm.address')}
        {...this.props}
      >
        {this.props.children}
      </AddressFields>
    );
  }
}

module.exports = ShippingAddressFields;



// WEBPACK FOOTER //
// ./javascripts/components/addresses/shipping_address_fields.jsx